import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watch, onMounted, computed} from "vue";
import { PlotData } from "@/components/Impedance";
import Plotly from "plotly.js-dist-min";

interface PlotConfig{
    zeroline: boolean;
}
/* eslint-disable-next-line */

export default /*#__PURE__*/_defineComponent({
  __name: 'NyquistPlot',
  props: {
    data: null,
    config: null
  },
  setup(__props: any) {

const props = __props as {
    data: PlotData[],
    config?: PlotConfig
}



let graph = ref(null);
let yInverted = computed(()=>{
    let output = [];
    if(props.data){
        for(var i=0; i<props.data.length; ++i){
            let trace = props.data[i];
            console.log("trace", trace);
            if(trace===undefined){
                continue;
            }
            output.push({
                x: trace.rs.map((rs:number)=>rs),
                y: trace.x.map((x:number)=>-x),
                text: trace.f.map((f:number)=>`${f} Hz`),
                name: trace.name,
                mode: "lines",
                type: "scatter"
            });

            if("rs_calc" in trace && "x_calc" in trace && "f_calc" in trace){
                output.push({
                    x: trace.rs_calc?.map((rs:number)=>rs),
                    y: trace.x_calc?.map((x:number)=>-x),
                    text: trace.f_calc?.map((f:number)=>`${f} Hz`),
                    name: trace.name + " (fitting)",
                    mode: "markers",
                    type: "scatter"
                });
            }
        }
    }
    return output as Plotly.Data; 
});

let config = computed(()=>(props.config)?props.config:{});

watch(yInverted, (_, oldval)=>{
    if(!graph.value){
        return;
    }
    return Plotly.react(
            graph.value,
            {data: oldval, layout: (graph.value as any).layout}
        ).then(()=>{
            return Plotly.update(
                graph.value,
                yInverted.value,
                null,
            );
        }).then(()=>{
            return Plotly.animate(
                graph.value, 
                {
                    data: yInverted.value
                },
                {
                    transition: {
                        duration: 200,
                        easing: 'cubic-in-out'
                    },
                    frame:{
                        duration: 200
                    }
                }
            );
        }).then(()=>{
            //calculate data range ratio(x-y)
            const ranges = calcRange(yInverted.value, config.value);
            //execute autorange animation
            return Plotly.animate(
                graph.value, 
                {   
                    layout: {
                        xaxis: {
                            range: ranges.xrange,                                                 
                        },
                        yaxis: {
                            range: ranges.yrange,
                        }
                    }
                },
                {
                    transition: {
                        duration: 1000,
                        easing: 'cubic-in-out'
                    }
                }
                
            );
        }).then(()=>{
            return Plotly.react(
                graph.value,
                {data: yInverted.value, layout: (graph.value as any).layout}
            )
        }).catch((e)=>{
            //do nothing
        });
    }
);

onMounted(()=>{
    //define default layout
    let layout = {
        automargin: true,
        autosize: true,
        xaxis: {
            autorange: true,
            zeroline: true,
            rangemode: "tozero",
            title: "Re(Z) [ohm]"
        },
        yaxis: {
            autorange: true,
            rangemode: "tozero",
            scaleanchor: "x",
            scaleratio: 1,
            title: "-Im(Z) [ohm]"
        },legend: {
            x: 1,
            xanchor: 'right',
            y: 1
        }
    };

    let config = {
        responsive: true
    };

    Plotly.newPlot(graph.value, yInverted.value, layout, config);
});

const calcRange = function(traces:any, config:any){
    const area = (graph.value as any).querySelector("rect.nsewdrag.drag");
    const graph_w = area.getAttribute("width");
    const graph_h = area.getAttribute("height");

    let xmin = Math.min(...traces.map(trace=>Math.min(...trace.x)));
    let xmax = Math.max(...traces.map(trace=>Math.max(...trace.x)));
    let ymin = Math.min(...traces.map(trace=>Math.min(...trace.y)));
    let ymax = Math.max(...traces.map(trace=>Math.max(...trace.y)));
    
    xmin = (xmin === Infinity)?-1:xmin;
    xmax = (xmax === -Infinity)?1:xmax;
    ymin = (ymin === Infinity)?-1:ymin;
    ymax = (ymax === -Infinity)?1:ymax;
    
    if(config.zeroline){
        if(xmin > 0){
            xmin = 0;
        }
        if(xmax < 0){
            xmax = 0;
        }
        if(ymin > 0){
            ymin = 0;
        }
        if(ymax < 0){
            ymax = 0;
        }
    }



    const marginx = Math.abs((xmax - xmin)/100);
    const marginy = Math.abs((ymax - ymin)/100);

    xmin = xmin - marginx;
    xmax = xmax + marginx;
    ymin = ymin - marginy;
    ymax = ymax + marginy;

    const data_w = (xmax-xmin);
    const data_h = (ymax-ymin);
    
    
    let xrange = [xmin,xmax];//init
    let yrange = [ymin,ymax];//init

    //compare ratio
    if(graph_h >= graph_w * data_h / data_w){
        yrange = [ymin, ymin + data_w * graph_h/ graph_w]; 
    }else{
        xrange = [xmin, xmin + data_h * graph_w / graph_h];
    }
    return {xrange, yrange};
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "graph",
    ref: graph
  }, null, 512))
}
}

})